export default function sendFlatPostMessage(flatId) {
    window.parent.postMessage({
        action: 'openPropertyRBI',
        data  : {
            propertyId: flatId
        }
    }, '*');
}
